import * as React from 'react'
const SvgBeach = ({ color = 'currentColor', size = '1em', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 43 43"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M16.11 33.86a.524.524 0 0 1-.524-.454c-.666-4.971-1.961-9.906-3.747-14.249-3.29 2.522-3.114 7.702-3.08 7.738 0 .28-.174.49-.455.56a.546.546 0 0 1-.595-.386c-1.12-4.34-.07-7.945.561-9.52-3.992.768-7.177 7.315-7.177 7.384a.51.51 0 0 1-.56.28c-.245-.035-.419-.209-.419-.454C-.83 17.48 4.7 15.1 6.975 14.467c-1.857-1.435-5.216-.804-5.251-.804a.54.54 0 0 1-.56-.281.58.58 0 0 1 .07-.629c3.22-3.325 6.93-1.89 8.541-.98.14-1.857.98-5.743 5.53-6.583a.54.54 0 0 1 .56.28.59.59 0 0 1-.07.632c-.035.033-2.416 2.518-2.24 4.83 1.786-1.54 6.826-4.83 12.392-.036.176.14.245.386.14.631-.104.21-.314.35-.559.315-.071 0-7.282-.981-10.118 1.926 1.645.35 5.216 1.468 8.228 4.794a.535.535 0 0 1 0 .7.5.5 0 0 1-.7.072c-.036-.036-4.342-3.117-8.297-1.681.629 1.821 2.94 8.506 4.585 15.193a.52.52 0 0 1-.995.308l-1.654.302a.53.53 0 0 1-.431.369c.035.036 0 .036-.036.036"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M42.469 37.817H8.549a.54.54 0 0 1-.524-.526c0-2.916 6.654-4.633 13.363-5.094v2.364c0 .902.75 1.654 1.654 1.654H38.76c.907 0 1.619-.755 1.619-1.654v-.122c1.719.814 2.616 1.788 2.616 2.852 0 .281-.245.526-.526.526"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M38.76 35.087h-5.007V29.24a1.03 1.03 0 0 0-1.05-1.05h-3.64a1.03 1.03 0 0 0-1.05 1.05v5.847h-4.97a.54.54 0 0 1-.527-.527v-7.423l-.49.493a.53.53 0 0 1-.386.14.53.53 0 0 1-.383-.14.505.505 0 0 1 0-.735l9.275-9.278a.53.53 0 0 1 .386-.138c.14 0 .28.069.386.138l9.241 9.278a.51.51 0 0 1 0 .735.51.51 0 0 1-.735 0l-.56-.564v7.494c.034.281-.212.527-.49.527m-9.697-.212h3.676V29.24h-3.642zm4.795-7.876h-5.88a.54.54 0 0 1-.526-.526v-3.43c0-.279.245-.524.526-.524h5.88c.281 0 .526.245.526.524v3.43a.54.54 0 0 1-.526.526m-5.356-1.05h1.89v-2.38h-1.89zm2.942 0h1.89v-2.38h-1.89zM34.018 18.743a.9.9 0 0 1 .121-.25l1.26-1.26c.104-.104.245-.175.385-.14.14 0 .281.07.386.174l1.223 1.262c.105.105.14.245.14.35v3.395z"
                clipRule="evenodd"
            />
        </svg>
    )
}
export default SvgBeach
